module.exports = __webpack_public_path__ + "img/icon-refresh.4cee50e5.svg";